import type { VAxios } from '../../define/axios/Axios';

import {
  InspirationParams,
  Inspiration,
  InspirationNewVersionParams,
  InspirationListParam,
  InspirationAttribute,
  InspirationAttributeCategories,
  InspirationFile,
  ReferenceDetail,
  ReferenceChannel,
  ReferenceParams,
  ReferenceListItem,
  InspirationDownload,
  Report,
  createNewVersionDetailRes,
  InspirationDebugger,
  InspirationVersion,
} from '../../entities/cc/inspirations.entities';
import { ErrorMessageMode } from '/#/axios';

/**
 * 灵感模块接口
 */
export const createApi = (defHttp: VAxios) => ({
  //#region 灵感接口
  // 查询灵感
  getReferences: (params: ReferenceParams) =>
    defHttp.get<ReferenceListItem[]>({ url: `/aiad/inspirations`, params }),
  // 根据 ID 查询灵感详情
  getReferenceDetail: (id: string) =>
    defHttp.get<ReferenceDetail>({ url: `/aiad/inspirations/${id}` }),
  // 获取频道
  getReferenceChannels: (solution) =>
    defHttp.get<ReferenceChannel[]>({ url: '/aiad/inspiration/channels', params: { solution } }),
  /**
   * 查询灵感已采集的文件夹
   * @param {string} id id
   * @returns
   */
  getCollectedDirs: (id: string) => {
    return defHttp.get<Array<string>>({ url: `/aiad/inspirations/${id}/collection-dirs` });
  },
  // 获取推荐词
  getRecommends: () => {
    return defHttp.get<string[]>({ url: '/aiad/inspiration/recommends' });
  },

  // 获取历史记录
  getHistories: () => {
    return defHttp.get<string[]>({ url: '/aiad/inspiration/records' });
  },

  // 清空历史记录
  removeHistories: () => {
    return defHttp.delete({ url: '/aiad/inspiration/records' });
  },
  //#endregion

  //#region 灵感生成接口
  // 新建灵感生成记录
  create: (params: InspirationParams, errorMessageMode?: ErrorMessageMode) =>
    defHttp.post({ url: `/aiad/inspiration/creations`, params }, { errorMessageMode }),

  // 获取灵感生成记录详情
  getCreation: (id: string) => {
    return defHttp.get<Inspiration>({ url: `/aiad/inspiration/creations/${id}` });
  },

  // 删除灵感记录
  deleteCreation: (id: string) => {
    return defHttp.delete({ url: `/aiad/inspiration/creations/${id}` });
  },
  // 修改灵感生成记录
  setCreation: (id: string, params: { topic: string }) => {
    return defHttp.put<Inspiration>({ url: `/aiad/inspiration/creations/${id}`, params });
  },

  // 修改灵感生成记录参数信息
  setCreationDebugger: (
    id: string,
    params: {
      num: number;
      debugger: InspirationDebugger;
      topic: string;
    },
  ) => {
    return defHttp.post({ url: `/aiad/inspiration/creations/${id}/debugger`, params });
  },

  // 临时灵感作品保存成正式作品
  saveCreation: (id: string) => {
    return defHttp.post({ url: `/aiad/inspiration/creations/${id}/save` });
  },

  // 获取灵感生成记录列表
  getCreationList: (params: InspirationListParam) => {
    return defHttp.get({ url: '/aiad/inspiration/creations', params });
  },
  // 创建新版本
  createNewVersion: (
    id: string,
    params: InspirationNewVersionParams,
    errorMessageMode?: ErrorMessageMode,
  ) => {
    return defHttp.post<string>(
      { url: `/aiad/inspiration/creations/${id}/versions`, params },
      { errorMessageMode },
    );
  },

  // 新版本详情
  createNewVersionDetail: (params: { id: string; versionId: string }) => {
    return defHttp.get<createNewVersionDetailRes>({
      url: `/aiad/inspiration/creations/${params.id}/versions/${params.versionId}`,
    });
  },
  download: (id: string, params: InspirationDownload) => {
    return defHttp.post<string>({ url: `/aiad/inspiration/creations/${id}/download`, params });
  },
  // 获取可选作图数量
  getCreationsNums: () => {
    return defHttp.get<{
      key: string;
      text: string;
    }>({ url: '/aiad/inspiration/creations/nums' });
  },
  // 创作历史
  getCreationsHistory: (params) => {
    return defHttp.get<{
      items: InspirationFile[];
      total: number;
    }>({ url: `/aiad/inspiration/creations/history`, params });
  },
  //#endregion

  //#region 细化参数接口
  // 查询细化参数
  queryAttributes: (params) => {
    return defHttp.get<InspirationAttribute>({ url: '/aiad/attributes', params });
  },
  // 查询细化参数分类
  queryAttributeCategories: (params) => {
    return defHttp.get<Array<InspirationAttributeCategories>>({
      url: '/aiad/attributes/categories',
      params,
    });
  },
  // 查询细化参数类型
  queryAttributeTypes: () => {
    return defHttp.get<
      Array<{
        attributeTypeEn: string;
        attributeTypeZh: string;
        hasUrl: boolean;
        total: string;
      }>
    >({ url: '/aiad/attributes/types' });
  },

  report: (params: Report) => {
    return defHttp.post<void>({
      url: '/aiad/inspirations/report',
      params,
    });
  },

  inspirationRelease: (params) => {
    return defHttp.post<void>({
      url: '/aiad/inspiration/creations/release',
      params,
    });
  },

  getVersions: (
    id: string | number,
    params: {
      afterId?: string | number;
      page: number;
    },
  ) => {
    return defHttp.get<InspirationVersion[]>({
      url: `/aiad/inspiration/creations/${id}/versions`,
      params,
    });
  },
  //#endregion
});
